import type { components } from '@connected/api-client/api.generated';

import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useValidation({
    electricalProjectVersionId,
    kind,
}: {
    electricalProjectVersionId: string;
    kind: components['schemas']['CreateElectricalProjectDocumentKind'];
}) {
    const validationQuery = useQuery({
        ...elektraAppQueryOptions.project.validateOptions({
            electricalProjectVersionId,
            kind,
        }),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    });

    const validationItems = useMemo(() => {
        return validationQuery.data?.ValidationResults?.filter(x => x.ObjectKind !== 'CheckListItem') || [];
    }, [validationQuery.data?.ValidationResults]);

    return {
        validationItems,
        refetch: validationQuery.refetch,
        hasErrors: (validationQuery.data?.ValidationResults?.length ?? 0) > 0,
    };
}
